import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class AuthenticatedIdrDashboardForgivenessEstimatorIndexRoute extends Route {
  @service declare store: StoreService;

  model() {
    return this.modelFor('authenticated.idr.dashboard.index');
  }
}
